/**
 * Écrire un nombre du jeu de l'élève : ses XP, ses pétales, un gain, un prix.
 *
 * Une seule écriture pour les compteurs, la chip de gain, la carte de quête et la boutique. À
 * remonter dans `ports/primary/ui/formatters` au câblage.
 */
export type GameUnit = "xp" | "petals"

/** « 2 450 » : les milliers séparés comme le reste de l'app les écrit (`moneyFormatter`). */
const COUNT_FORMAT = new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 })

export function formatCount(count: number): string {
    return COUNT_FORMAT.format(count)
}

/** Entre un nombre et son unité : une espace insécable, l'unité ne passe jamais seule à la ligne. */
const NBSP = " "

/** « XP », « pétales », « pétale » : l'unité seule, accordée au nombre qu'on écrit à part. */
function formatUnit(amount: number, unit: GameUnit): string {
    if (unit === "xp") return "XP"
    return amount > 1 ? "pétales" : "pétale"
}

/** « 2 450 XP », « 245 pétales », « 1 pétale » : un nombre et son unité, accordée. */
export function formatAmount(amount: number, unit: GameUnit): string {
    return `${formatCount(amount)}${NBSP}${formatUnit(amount, unit)}`
}

/** « +25 XP », « +1 pétale », « +10 pétales ». */
export function formatGain(amount: number, unit: GameUnit = "xp"): string {
    return `+${formatAmount(amount, unit)}`
}
